// @ts-nocheck
import withSystemHealthLoader from './SystemHealthLoader';

export default withSystemHealthLoader;
